import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/olympics/2024/Index.vue')
const Ranking = () => import('../activity/olympics/2024/Ranking.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/olympics/2024',
  name: 'activity_olympics_2024',
  component: Index,
  meta: {
    title: 'S+奥运总动员',
    expiryDate: '2024-08-24',
  },
}

export const rankingRoute: RouteConfig = {
  path: '/activity/olympics/2024/ranking',
  name: 'activity_olympics_2024_ranking',
  component: Ranking,
  meta: {
    title: 'S+荣耀加冕排行榜',
    expiryDate: '2024-08-24',
  },
}

export default []
